export default __webpack_public_path__ + "assets/images/be00ea5172a3ef47cb54f60cba12cf52.svg";